import MODULE_ID from './moduleId';
import routeHandler from './routes';

const module = {
  moduleType: 'Media',
  moduleId: MODULE_ID,
  api: 'media',
  path: 'media',
  routeHandler,
};

export default module;
